import { ReactElement } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import FourTileGrid1 from './grids/FourTileGrid1';
import FourTileGrid2 from './grids/FourTileGrid2';

import {
  configHas1Application,
  configHas2Applications,
  configHas3Applications,
  configHas4Applications,
} from './utils/assertConfigAppsSize';

import { Application } from '../../types';
import FiveTileGrid1 from './grids/FiveTileGrid1';
import FiveTileGrid2 from './grids/FiveTileGrid2';

declare const APPLICATIONS: Application[];

export default function DefaultView(): ReactElement {
  if (configHas1Application(APPLICATIONS))
    return <FourTileGrid1 application={APPLICATIONS} />;
  if (configHas2Applications(APPLICATIONS))
    return <FourTileGrid2 applications={APPLICATIONS} />;
  if (configHas3Applications(APPLICATIONS))
    return <FiveTileGrid1 applications={APPLICATIONS} />;
  if (configHas4Applications(APPLICATIONS))
    return <FiveTileGrid2 applications={APPLICATIONS} />;

  return (
    <Box
      sx={{
        width: 1,
        height: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography variant="h2" color="error">
        There is no grid for the provided configuration.
      </Typography>
    </Box>
  );
}
